import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import { toUtcIsoString } from '@utils/date'
import { CallsStore, IRecordCall, RecordCallPayload } from './types'

export const useCallsStore = create<CallsStore>()(
  devtools(() => ({
    getUserCalls: async (userId: number) => {
      try {
        // already ordered by date, newest first
        const response = await http.get(`/user/${userId}/record_call`)

        if (!Array.isArray(response)) {
          return []
        }

        // the endpoint returns the UTC instant without a timezone suffix, so
        // it has to be tagged as UTC before any local formatting happens
        return (response as IRecordCall[]).map(call => ({
          ...call,
          date: toUtcIsoString(call.date) ?? call.date
        }))
      } catch (error) {
        console.error('Error fetching user calls:', error)
        return []
      }
    },

    logUserCall: async (userId: number, payload: RecordCallPayload) => {
      try {
        // the professional is taken from the token, never sent in the body
        const response = await http.post(`/user/${userId}/record_call`, payload)

        return { success: Boolean(response?.success) }
      } catch (error) {
        console.error('Error logging user call:', error)
        return { success: false }
      }
    }
  }))
)
